import { NotificationBell } from "./NotificationBell";
import { CenterSwitcherPill } from "./CenterSwitcherPill";
import { Menu } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useSidebar } from "@/components/ui/sidebar";

export function AppHeader() {
  const { toggleSidebar, isMobile } = useSidebar();

  return (
    <div className="flex items-center justify-between w-full px-2 sm:px-4 gap-2">
      <div className="flex items-center gap-3 flex-1 min-w-0">
        {isMobile && (
          <Button variant="ghost" size="icon" onClick={toggleSidebar} className="md:hidden shrink-0">
            <Menu className="h-5 w-5" />
          </Button>
        )}
      </div>
      <div className="flex items-center gap-2">
        <CenterSwitcherPill />
        <NotificationBell />
      </div>
    </div>
  );
}
